import React, { lazy, Suspense } from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { LanguageDetector } from './components/LanguageRouter';
import { Toaster } from './components/ui/sonner';

// Lazy-load pages for better performance
const HomePage = lazy(() => import('./pages/HomePage'));
const BlogPage = lazy(() => import('./pages/BlogPage'));
const ArticlePage = lazy(() => import('./pages/ArticlePage'));
const AdminPage = lazy(() => import('./pages/AdminPage'));

const PageLoader = () => (
  <div className="min-h-screen bg-[#fafafa] flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-[#16a34a] border-t-transparent rounded-full animate-spin" />
  </div>
);

// Core page routes
const PageRoutes = () => (
  <Routes>
    <Route path="/" element={<HomePage />} />
    <Route path="/blog" element={<BlogPage />} />
    <Route path="/blog/:slug" element={<ArticlePage />} />
    <Route path="/admin" element={<AdminPage />} />
    <Route path="*" element={<HomePage />} />
  </Routes>
);

// French routes wrapper
const FrRoutes = () => (
  <>
    <LanguageDetector />
    <PageRoutes />
  </>
);

// Spanish routes wrapper
const EsRoutes = () => (
  <>
    <LanguageDetector />
    <PageRoutes />
  </>
);

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <div className="App min-h-screen bg-[#fafafa]">
          <BrowserRouter>
            <Navbar />
            <main>
              <Suspense fallback={<PageLoader />}>
                <Routes>
                  {/* French language routes */}
                  <Route path="/fr/*" element={<FrRoutes />} />
                  {/* Spanish language routes */}
                  <Route path="/es/*" element={<EsRoutes />} />
                  {/* Default English routes */}
                  <Route path="/" element={<HomePage />} />
                  <Route path="/blog" element={<BlogPage />} />
                  <Route path="/blog/:slug" element={<ArticlePage />} />
                  <Route path="/admin" element={<AdminPage />} />
                  <Route path="*" element={<HomePage />} />
                </Routes>
              </Suspense>
            </main>
            <Footer />
          </BrowserRouter>
          <Toaster position="bottom-right" />
        </div>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
